import handleResponse from "./handleResponse";

export function addContactDetails(data, token) {
  const header = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
  const requestOptions = {
    method: "POST",
    headers: header,
    body: JSON.stringify(data)
  };

  return fetch(`${process.env.REACT_APP_API_ENDPOINT}contactUs`, requestOptions)
    .then(handleResponse)
    .then(user => {
      return user;
    });
}



